import { render, staticRenderFns } from "./RolesTable.vue?vue&type=template&id=846970a0"
import script from "./RolesTable.vue?vue&type=script&lang=js"
export * from "./RolesTable.vue?vue&type=script&lang=js"
import style0 from "./RolesTable.vue?vue&type=style&index=0&id=846970a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports